import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";

const CODE = "URBANWELCOME";

// Old table-stand QR link (/s/conversionCard, any /s/* path) -> menu with the welcome code applied and shown in the top banner.
export function ConversionCardRedirect() {
  const { search } = useLocation();
  const { setCoupon } = useCart();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setCoupon(CODE);
    try { localStorage.removeItem("urban_welcome_dismissed"); } catch { /* ignore */ }
    setReady(true);
  }, [setCoupon]);
  return ready ? <Navigate to={`/store/restaurant${search}`} replace /> : null;
}
